import { FC, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { Title4, Title5 } from './styles/Typography'
import { theme } from '../theme/theme'
import { useWindowWidth } from '../hooks/useWindowWidth'
import { isMobile } from '../utils/devices'

export type TabData = {
  label: string
  content: React.ReactNode
  slug: string
}

export const Tabs: FC<{ tabs: TabData[] }> = ({ tabs }) => {
  const { id } = useParams()
  const [activeTab, setActiveTab] = useState<number>(0)
  const navigate = useNavigate()
  const width = useWindowWidth()
  const isMobileDevice = isMobile(width)

  useEffect(() => {
    const activeTabBySlug = tabs.findIndex((tab) => tab.slug === id)
    setActiveTab(activeTabBySlug)
  }, [id, tabs])

  return (
    <>
      <TabGroup>
        {tabs.map((tab, index) => (
          <TabContainer key={index}>
            <StyledTab
              key={`tab-${index}`}
              onClick={() => {
                setActiveTab(index)
                navigate(`/portal/your-health/${tab.slug}`)
              }}
            >
              {isMobileDevice ? <Title5>{tab.label}</Title5> : <Title4>{tab.label}</Title4>}
            </StyledTab>
            <UnderLine key={`underline-${index}`} className={index === activeTab ? 'active' : ''} />
          </TabContainer>
        ))}
      </TabGroup>
      {tabs.map((tab, index) => index === activeTab && <div key={index}>{tab.content}</div>)}
    </>
  )
}

const TabGroup = styled.div`
  display: flex;
  flex-direction: row;
  z-index: 999;
  width: 700px;
  margin-left: ${theme.spacing.xlarge}px;
  @media screen and (max-width: ${theme.breakpoint.large}px) {
    width: 90%;
    margin: 0 auto;
    padding-bottom: ${theme.spacing.medium}px;
  }
`

const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: -2px;
`

const StyledTab = styled.button`
  cursor: pointer;
  width: 100%;
  height: 61px;
  border: none;
  background-color: transparent;
  font-family: ${theme.font.body};
  color: ${theme.color.black};
  @media screen and (max-width: ${theme.breakpoint.large}px) {
    height: 50px;
  }
`

const UnderLine = styled.span`
  width: 100%;
  height: 5px;
  background-color: ${theme.color.grey3};
  border-radius: 50px;
  &.active {
    background-color: ${theme.color.plum};
    z-index: 1;
  }
`
